module.exports = {"120106001":"西于庄街道","120106002":"双环村街道","120106003":"咸阳北路街道","120106004":"丁字沽街道","120106005":"西沽街道","120106006":"三条石街道","120106008":"邵公庄街道","120106009":"芥园街道","120106010":"铃铛阁街道","120106011":"大胡同街道","120106012":"和苑街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120106.json
// module id = 45
// module chunks = 0